(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gz-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (root.getAttribute('data-ready')) return;
      root.setAttribute('data-ready', '1');

      var track = root.querySelector('.gz-track');
      var slides = [].slice.call(root.querySelectorAll('.gz-slide'));
      var dots = [].slice.call(root.querySelectorAll('.gz-dot'));
      var count = slides.length;
      if (count < 2) return;

      var index = 0;
      var timer = null;
      var delay = parseInt(root.getAttribute('data-speed'), 10) || 5000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var editing = window.Shopify && window.Shopify.designMode;
      var auto = root.getAttribute('data-autoplay') === 'true' && !reduce && !editing;

      function go(k) {
        index = (k + count) % count;
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        slides.forEach(function (slide, j) {
          slide.setAttribute('aria-hidden', j === index ? 'false' : 'true');
        });
        dots.forEach(function (dot, j) {
          if (j === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() {
        if (!auto) return;
        stop();
        timer = setInterval(function () { go(index + 1); }, delay);
      }

      var prev = root.querySelector('.gz-prev');
      var next = root.querySelector('.gz-next');
      if (prev) prev.addEventListener('click', function () { go(index - 1); play(); });
      if (next) next.addEventListener('click', function () { go(index + 1); play(); });
      dots.forEach(function (dot, j) {
        dot.addEventListener('click', function () { go(j); play(); });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else play();
      });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { go(index - 1); play(); }
        if (e.key === 'ArrowRight') { go(index + 1); play(); }
      });

      var startX = 0, startY = 0;
      root.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        stop();
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? index + 1 : index - 1);
        play();
      }, { passive: true });

      root.gzGoTo = go;
      go(0);
      play();
    }

    function initAll() {
      [].slice.call(document.querySelectorAll('.gz-slider')).forEach(initSlider);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    /* Editor de temas de Shopify */
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest ? e.target.closest('.gz-slider') : null;
      if (!root || !root.gzGoTo) return;
      var slides = [].slice.call(root.querySelectorAll('.gz-slide'));
      var k = slides.indexOf(e.target);
      if (k > -1) root.gzGoTo(k);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gz-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var track = root.querySelector('.rv-track');
      var prev = root.querySelector('.rv-prev');
      var next = root.querySelector('.rv-next');
      if (!track || !prev || !next) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max;
      }
      function step() {
        var card = track.querySelector('.review');
        return card ? card.getBoundingClientRect().width + 12 : 280;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function all() { document.querySelectorAll('[data-rv]').forEach(init); }
    all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gz-trust"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.trReady) return;
      root.dataset.trReady = '1';
      var track = root.querySelector('.trust-track');
      var dotsBox = root.querySelector('.tr-dots');
      var items = track ? track.querySelectorAll('.trust-item') : [];
      if (!track || items.length < 2) return;

      var auto = root.dataset.autoplay === 'true';
      var speed = (parseFloat(root.dataset.speed) || 4) * 1000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null, paused = false;

      function overflow() { return track.scrollWidth > track.clientWidth + 4; }
      function stepW() { return items[1].offsetLeft - items[0].offsetLeft; }
      function maxIndex() { return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / stepW())); }

      var dots = [];
      function buildDots() {
        dotsBox.innerHTML = ''; dots = [];
        if (!overflow()) { dotsBox.classList.remove('is-on'); return; }
        for (var i = 0; i <= maxIndex(); i++) {
          (function (n) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', (n + 1) + ' / ' + (maxIndex() + 1));
            b.addEventListener('click', function () { goTo(n); restart(); });
            dotsBox.appendChild(b); dots.push(b);
          })(i);
        }
        dotsBox.removeAttribute('aria-hidden');
        dotsBox.classList.add('is-on');
        mark();
      }
      function current() { return Math.min(maxIndex(), Math.round(track.scrollLeft / stepW())); }
      function mark() {
        var c = current();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
      }
      function goTo(n) { track.scrollTo({ left: n * stepW(), behavior: 'smooth' }); }
      function next() {
        if (!overflow()) return;
        var n = current() + 1;
        goTo(n > maxIndex() ? 0 : n);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (auto && !reduce && !paused) timer = setInterval(next, speed);
      }
      function restart() { start(); }

      track.addEventListener('scroll', mark, { passive: true });
      root.addEventListener('mouseenter', function () { paused = true; stop(); });
      root.addEventListener('mouseleave', function () { paused = false; start(); });
      root.addEventListener('touchstart', function () { paused = true; stop(); }, { passive: true });
      root.addEventListener('touchend', function () { paused = false; setTimeout(start, 4000); }, { passive: true });
      root.addEventListener('focusin', function () { paused = true; stop(); });
      root.addEventListener('focusout', function () { paused = false; start(); });
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      window.addEventListener('resize', buildDots);

      buildDots();
      start();
    }
    function all() { document.querySelectorAll('[data-tr]').forEach(init); }
    all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-gz-header]');
    if (!header) return;
    var btn = header.querySelector('.menu-toggle');
    var nav = header.querySelector('.nav');
    if (!btn || !nav) return;
    function set(open) {
      nav.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    btn.addEventListener('click', function () { set(!nav.classList.contains('is-open')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) set(false); });
    window.addEventListener('resize', function () { if (window.innerWidth > 760) set(false); });
  })();

  } catch(e) { console.error(e); }
})();
})();
